// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__IeXt-","lineButtons":"vehicleItem_lineButtons__c1pu5","twoInLine":"vehicleItem_twoInLine__MAEnu"};